import EventEmitter from 'eventemitter3';
export default new EventEmitter();



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/dataProvider/undoableEventEmitter.js
// module id = 391
// module chunks = 0